module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch6aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch6a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch6"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("LET "), _c('i', [_vm._v("ME")]), _vm._v(" WRITE SIGN—I GOOD SPEAK ENGLISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("When signs in foreign countries are written in English, any combination of words is possible. Here are some real-life examples")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("A sign in China (instructing people to keep off the grass)")]), _vm._v(":")]), _vm._v(" “I like your smile but unlike you put your shoes on my face”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("Outside a restaurant in Istanbul:")])]), _vm._v(" “Sorry We’re Open”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("Outside a Thai building:")])]), _vm._v(" “Welcome to visit elephant dung factory & souvenir shop”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("On the border between Paraguay and Argentina:")])]), _vm._v(" “The paths to our resort are only passable by asses. Therefore, you will certainly feel at home here”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("At a Hong Kong train station:")])]), _vm._v(" “The toilets will be partially suspended for use”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Next to a staircase in Japan:")])]), _vm._v(" “Please be careful about a step in a head”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Outside a restaurant in the Philippines:")])]), _vm._v(" “Try Our Fresh Deli Sandwiches Made with Imported Europeans Meat and Cheese”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Outside a Singapore restroom:")])]), _vm._v(" “A nearby toilet should be used for the direction of hurry”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("On a path in Hiroshima:")])]), _vm._v(" “10 Min. Walk (7 if run a little) to Ropeway Stn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("Inside Afghanistan’s Kabul Museum:")])]), _vm._v(" “Please Do Not Use the Flashy Cameras During the Photography”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("On a winding road in India:")])]), _vm._v(" “Be Soft on My Curves”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("At a French ski resort:")])]), _vm._v(" “Skiers: Entrance Through the Bottom is Compulsory”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("At a zoo in China:")])]), _vm._v(" “Please do not feel or scare the animals”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Outside a church in Costa Rica:")])]), _vm._v(" “Please no explanations inside the church”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('span', [_c('b', [_c('i', [_vm._v("On a vending machine in Tokyo:")])]), _vm._v(" “Because I Do Not Have A Tissue Always Ready in This Restroom, Please Buy Used One”")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("Cookie Monster has five fingers; all other "), _c('i', [_vm._v("Sesame Street")]), _vm._v(" Muppets have only four.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ade600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter006.vue
// module id = 96
// module chunks = 0